const MINIMUM_AGE = 18;
const MIN_BIRTH_YEAR = 1900;

export const getMinimumValidBirthDate = (): Date => {
  const today = new Date();
  const minDate = new Date(today);
  minDate.setFullYear(today.getFullYear() - MINIMUM_AGE);
  minDate.setMonth(today.getMonth());
  minDate.setDate(today.getDate());
  minDate.setHours(0, 0, 0, 0);
  return minDate;
};

export const getMaximumValidBirthDate = (): Date => {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return today;
};

export const getMaximumValidYear = (): number => {
  const today = new Date();
  return today.getFullYear() - MINIMUM_AGE;
};

export const getMinimumValidYear = (): number => {
  return MIN_BIRTH_YEAR;
};

export const getValidYears = (): number[] => {
  const maxYear = getMaximumValidYear();
  const minYear = getMinimumValidYear();
  const years: number[] = [];

  for (let year = maxYear; year >= minYear; year--) {
    years.push(year);
  }

  return years;
};

export const calculateAge = (birthDate: Date): number => {
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};

export const validateBirthDate = (
  birthDate: Date | string | null | undefined
): { isValid: boolean; error?: string } => {
  if (!birthDate) {
    return { isValid: false, error: "Date of birth is required" };
  }

  let date: Date;

  if (typeof birthDate === "string") {
    date = new Date(birthDate);
  } else {
    date = birthDate;
  }

  if (isNaN(date.getTime())) {
    return { isValid: false, error: "Invalid date format" };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const dateOnly = new Date(date);
  dateOnly.setHours(0, 0, 0, 0);

  const minDate = new Date("1900-01-01");
  minDate.setHours(0, 0, 0, 0);

  if (dateOnly > today) {
    return { isValid: false, error: "Date of birth cannot be in the future" };
  }

  if (dateOnly < minDate) {
    return { isValid: false, error: "Date of birth cannot be before 1900" };
  }

  const age = calculateAge(dateOnly);

  if (age < MINIMUM_AGE) {
    return { isValid: false, error: "You must be at least 18 years old" };
  }

  return { isValid: true };
};
